import React, { useMemo, } from 'react';
import styled, { css } from 'styled-components';
import { SystemIcon } from '@storeblocks/icon';
function Attention({ title, variant = 'warning', visible = false, children, }) {
    const icon = useMemo(() => {
        if (variant === 'warning') {
            return (React.createElement(SystemIcon, { size: 24, name: "warning-filled", color: "warning-accent" }));
        }
        return React.createElement(SystemIcon, { size: 24, name: "error-filled", color: "error-accent" });
    }, [variant]);
    if (!visible) {
        return children;
    }
    return (React.createElement(AttentionBase, { variant: variant },
        React.createElement(Container, null,
            icon,
            title),
        children));
}
const AttentionBase = styled.div `
  display: inline-flex;
  flex-direction: column;

  background: var(--color-warning-background);
  outline: 3px solid var(--color-warning-accent);

  padding: 16px 32px 8px 16px;

  ${({ variant }) => {
    if (variant === 'warning') {
        return css `
        background: var(--color-warning-background);
      `;
    }
    return css `
      outline: 3px solid var(--color-error-accent);
      background: var(--color-error-background);
    `;
}}
`;
export const Container = styled.div `
  display: inline-flex;

  font-weight: 600;
  line-height: 24px;

  margin-bottom: 24px;

  & > i {
    margin-right: 24px;
  }
`;
export default Attention;
